module.exports = __webpack_public_path__ + "static/media/redux.ad6ef14b.png";